import { type UseQueryOptions, useQuery } from "@tanstack/react-query"
import type { TUser } from "@/types/common"
import { fetchAPISessionUserPeers } from "@/utils"

interface IProps extends Omit<UseQueryOptions<TUser[]>, "queryKey"> {
  sessionId: string
}

export function useAPISurveySessionPeers({ sessionId, ...props }: IProps) {
  return useQuery<TUser[]>({
    queryKey: ["peers", sessionId],
    queryFn: () => fetchAPISessionUserPeers(sessionId),
    ...props,
    enabled: !!sessionId,
  })
}
